import React, { useState, useEffect } from 'react';
//Redux
import store from './redux';
import { Provider } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation
} from "react-router-dom";

import FooterPagina from './componentes/General/FooterPagina2/index';
import Inicio from './componentes/General/Paginas/Inicio';
import Navbar from './componentes/General/NavBarPagina3/Navbar';
import ERPCloud from './componentes/General/Paginas/ERPCloud'
import Kalenday from './componentes/General/Paginas/Kalenday';
import ScrumWeb from './componentes/General/Paginas/Scrumweb';
import AboutUs from './componentes/General/Paginas/AboutUs';
import Contact from './componentes/General/Paginas/Contact';
import Servicios from './componentes/General/Paginas/Servicios';
import OnlineAssistant from './componentes/General/Paginas/onlineAssistant';
import Tutoriales from './componentes/General/Paginas/Tutoriales'
import Blog from './componentes/General/Paginas/Blog';
import NoticiaCFDI from './componentes/General/NoticiaCFDI/index';
import NoticiaBeneficiosCFDI from './componentes/General/NoticiaNovedadCFDI/index';
import ActivarCuenta from './componentes/General/Paginas/ActivarCuentas'
import SidenavPanelUsuario from 'componentes/General/SidenavPanelAdministrador';
import PaginaNoDisponible from './componentes/General/Paginas/NoDisponible';
import RecoverPass from '../src/componentes/General/Paginas/RecoverPassword';
import PreviewCarrito from 'componentes/General/PreviewCarrito';

import TTERP from 'componentes/General/Paginas/TTERP';
import TTCFDI from 'componentes/General/Paginas/TTCFDI';
import TTNOMINA from 'componentes/General/Paginas/TTNOMINA';
import InfoRedes from './componentes/General/InfoRedes/inforedes';


import { useSelector, useDispatch } from "react-redux";





function App() {

  const { usuario } = useSelector(state => state.login)
  const location = useLocation();

  const [auxCarrito, setAuxCarrito] = useState(false);


  const rutasSignedIn = [
    {
      path: '/activar-cuenta/:token',
      element: <ActivarCuenta />
    },
    {
      path: '/panelDeUsuario/:token',
      element: <SidenavPanelUsuario />
    }
  ]

  function rutasPrivadas() {

    let rutasPrivadas = rutasSignedIn.map(rutas => {
      return (<Route path={rutas.path}>
        {rutas.element}
      </Route>)
    })

    return (rutasPrivadas);
  }


  return (

    <Router  >
      {location.pathname.split('/')[1] !== 'panelDeUsuario' && location.pathname !== '/inforedes' ? <Navbar auxCarrito={auxCarrito} /> : <></>}
      <Switch>
        {/* <Route path='/recoverPass/:token' component={RecoverPass} />
        <Route path={'/panelDeUsuario/:token'}>
          <SidenavPanelUsuario />
        </Route>
        <Route path='/shoppingCart/:token'>
          <PreviewCarrito setAuxCarrito={setAuxCarrito} auxCarrito={auxCarrito} />
        </Route>
        <Route path='/activar-cuenta/:token'>
          <ActivarCuenta />
        </Route>
        <Route path='/softwoneERPCloud'>
          <ERPCloud />
        </Route>
        <Route path='/softwoneKalenday'>
          <Kalenday setAuxCarrito={setAuxCarrito} auxCarrito={auxCarrito} />
        </Route>
        <Route path='/softwoneScrumOne'>
          <ScrumWeb setAuxCarrito={setAuxCarrito} auxCarrito={auxCarrito} />
        </Route> */}
        <Route path='/aboutUs'>
          <AboutUs />
        </Route>
        {/* <Route path='/successStories'>
          <PaginaNoDisponible />
        </Route> */}
        {/*         <Route path='/contact'>
          <Contact />
        </Route> */}
        <Route path='/onlineAssistant'>
          <OnlineAssistant />
        </Route>
        {/* <Route path='/tutoriales'>
          <Tutoriales />
        </Route> */}
        <Route path='/blog'>
          <Blog />
        </Route>
        <Route path='/noticiaCFDI'>
          <NoticiaCFDI />
        </Route>
        <Route path='/noticiaBeneficiosCFDI'>
          <NoticiaBeneficiosCFDI />
        </Route>
        {/*<Route path='/services'>
          <Servicios />
        </Route> */}
        <Route path='/ttcfdi'>
          <TTCFDI />
        </Route>
        <Route path='/tterp'>
          <TTERP />
        </Route>
        <Route path='/ttnomina'>
          <TTNOMINA />
        </Route>
        <Route path='/inforedes'>
          <InfoRedes />
        </Route>
        <Route path='/'>
          <Inicio />
        </Route>

      </Switch>
      {location.pathname.split('/')[1] !== 'panelDeUsuario' && location.pathname !== '/inforedes' ? <FooterPagina /> : <></>}
    </Router>
  );
}

export default App;
